import React from 'react';
import { motion } from 'framer-motion';
import { invitationPoints } from '../../data/foundingProgram';
export function FoundingInvitation() {
  return <section className="border-b border-[#D4AF37]/12 bg-[#0B0A0E]" data-id="element-1405" data-mp="2acx5z4do3epq">
      <div className="mx-auto w-full max-w-7xl px-5 py-20 sm:px-8" data-id="element-1406" data-mp="2obepepwji51u">
        <div className="grid gap-12 lg:grid-cols-2 lg:items-center lg:gap-20" data-id="element-1407" data-mp="2jb0rw1skedi2">
          <div data-id="element-1408" data-mp="2y8t5goejwrtm">
            <p className="text-[10px] font-medium uppercase tracking-[0.32em] text-[#D4AF37]" data-id="element-1409" data-mp="2y89ll25cbtcy">
              The invitation
            </p>
            <h2 className="mt-5 font-serif text-3xl leading-tight text-[#FDFBF7] sm:text-5xl" data-id="element-1410" data-mp="2t96r2bmzl5j8">
              You are being invited to help shape this, at the earliest stage.
            </h2>
            <p className="mt-6 text-lg font-light leading-relaxed text-[#FDFBF7]/70" data-id="element-1411" data-mp="330sxluodqgfn">
              Founding membership is participation, not simply a purchase.
              What you bring, your judgement, your network, your support,
              becomes part of how this experience turns out.
            </p>
            <a href="#benefits" className="mt-8 inline-flex items-center justify-center border border-[#D4AF37]/45 px-7 py-4 text-[11px] font-bold uppercase tracking-[0.2em] text-[#D4AF37] transition-colors duration-150 ease-out hover:border-[#D4AF37] hover:bg-[#D4AF37]/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37]" data-id="element-1412" data-mp="lq8rrjak76wf">
              Explore Founding Membership
            </a>
          </div>

          <div className="grid grid-cols-2 gap-px border border-[#D4AF37]/15" data-id="element-1413" data-mp="19m3fpc265q7x">
            {invitationPoints.map((point, index) => {
            const Icon = point.icon;
            return <motion.div key={point.title} initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.28,
              delay: index * 0.05
            }} className="border-[#D4AF37]/15 p-7 [&:nth-child(-n+2)]:border-b [&:nth-child(odd)]:border-r" data-id="element-1414" data-mp="1jcy2qin8otuf" data-mpi={index}>
                  <Icon className="h-5 w-5 text-[#D4AF37]" aria-hidden="true" data-id="element-1415" data-mp="3kf77900e9s02" />
                  <h3 className="mt-5 font-serif text-lg text-[#FDFBF7]" data-id="element-1416" data-mp="20ocd2ddle7i">
                    {point.title}
                  </h3>
                  <p className="mt-2 text-sm font-light leading-relaxed text-[#FDFBF7]/55" data-id="element-1417" data-mp="3teaumg6lgtkd">
                    {point.body}
                  </p>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}